import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home/home.component';
import { SharedModule } from '../shared/shared.module';
import { OrderGridClientComponent } from './order-grid-client/order-grid-client.component';
import { OrderGridAdminComponent } from './order-grid-admin/order-grid-admin.component';



@NgModule({
  declarations: [
    HomeComponent,
    OrderGridClientComponent,
    OrderGridAdminComponent,
  ],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class OrdersModule { }
